import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import api from "../../api/axiosInstance";
import Logo from "../../assets/logosnake.jpg";
import "./VerifyResetotp.css";
import { verifyOtp } from "../../api/adminAuthApi";

export default function VerifyResetotp() {
  const navigate = useNavigate();
  const location = useLocation();

  const email = location.state?.email;
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // await api.post("/api/admin/otp/verify", {
      //   email,
      //   code: otp.toString(),
      // });

      const res = await verifyOtp({ email, otp: Number(otp) });
      if (res?.success) {
        toast.success("OTP verified");
        navigate("/Createnewpassword", { state: { email } });
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Invalid OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="right-panel">
        <form className="login-card" onSubmit={handleSubmit}>
          <img className="logo" src={Logo} alt="logo" />
          <h2>Verify OTP</h2>

          <p className="center">
            Enter the OTP sent to <br />
            <strong>{email}</strong>
          </p>

          <input
            type="text"
            className="otp-input"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            required
          />

          <button className="submit-btn" type="submit" disabled={loading}>
            {loading ? "Verifying..." : "Verify OTP"}
          </button>
        </form>
      </div>
    </div>
  );
}
